module.exports = __webpack_public_path__ + "static/media/DK4050_07.be76021a.jpg";